// `react-native` on the web: react-native-web, plus fixes for APIs that are
// no-ops or misleading in a browser. Add further overrides here.
import {Linking as RNWLinking} from 'react-native-web';
import Alert from './alert-api';

export * from 'react-native-web';

// react-native-web's Alert.alert does nothing, so dialogs silently vanish.
export {Alert};

// react-native-web reports every URL as openable, so app deep links like
// `comgooglemaps://` "succeed" and nothing happens. Only web schemes can open.
const WEB_SCHEMES = /^(https?|mailto|tel|sms):/i;
export const Linking = {
  ...RNWLinking,
  addEventListener: (...args) => RNWLinking.addEventListener(...args),
  canOpenURL: url => Promise.resolve(WEB_SCHEMES.test(String(url))),
  openURL: url => RNWLinking.openURL(url),
  getInitialURL: () => RNWLinking.getInitialURL(),
  openSettings: () =>
    Promise.reject(new Error('Settings cannot be opened from a browser')),
};

// Android-only API. Screens only call it behind Platform.OS === 'android', but
// they import it, so it has to exist.
export const PermissionsAndroid = {
  PERMISSIONS: new Proxy(
    {},
    {get: (_, name) => `android.permission.${String(name)}`},
  ),
  RESULTS: {
    GRANTED: 'granted',
    DENIED: 'denied',
    NEVER_ASK_AGAIN: 'never_ask_again',
  },
  check: () => Promise.resolve(false),
  request: () => Promise.resolve('denied'),
  requestMultiple: () => Promise.resolve({}),
};
